module.exports = __webpack_public_path__ + "static/colaboradores-07-7f916b83b55775ae0141bb0a67e3b645.png";